/*
 * Pure n' Bio — KSA Short National Address (العنوان الوطني المختصر)
 * Progressive enhancement for snippets/cart-national-address.liquid.
 * Core mandatory behaviour is native (required + pattern on the input
 * associated with form="cart"). This script adds: input normalisation,
 * a friendly inline error, and AJAX persistence to a cart attribute so
 * the value also survives express-wallet checkouts.
 */
(function () {
  'use strict';

  var INPUT_ID = 'cart-national-address-input';
  var ERROR_ID = 'cart-national-address-error';
  var FORMAT = /^[A-Za-z]{4}[0-9]{4}$/;

  function getInput() {
    return document.getElementById(INPUT_ID);
  }

  // Normalise: drop spaces, uppercase. Returns the cleaned string.
  function normalise(value) {
    return (value || '').replace(/\s+/g, '').toUpperCase();
  }

  function showError(input, message) {
    var box = document.getElementById(ERROR_ID);
    if (box) {
      box.textContent = message;
      box.hidden = false;
    }
    input.setAttribute('aria-invalid', 'true');
  }

  function clearError(input) {
    var box = document.getElementById(ERROR_ID);
    if (box) {
      box.textContent = '';
      box.hidden = true;
    }
    input.removeAttribute('aria-invalid');
  }

  // Debounced persistence to a cart attribute so the value carries into
  // checkout even for express wallets that bypass the cart form submit.
  var persistTimer = null;
  function persist(input) {
    if (persistTimer) clearTimeout(persistTimer);
    persistTimer = setTimeout(function () {
      var key = input.getAttribute('data-attribute-key');
      if (!key) return;
      var body = { attributes: {} };
      body.attributes[key] = input.value;
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      }).catch(function () {
        /* Non-fatal: native submit still saves the attribute. */
      });
    }, 400);
  }

  // Input normalisation (space-strip + uppercase) while preserving caret.
  document.addEventListener('input', function (event) {
    var input = event.target;
    if (!input || input.id !== INPUT_ID) return;
    var cleaned = normalise(input.value);
    if (cleaned !== input.value) {
      input.value = cleaned;
    }
    if (input.value === '' || FORMAT.test(input.value)) {
      clearError(input);
    }
    persist(input);
  });

  // Friendly inline validation on the cart form submit (checkout button).
  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form || form.id !== 'cart') return;
      var input = getInput();
      if (!input) return; // Not a KSA cart — nothing to enforce.
      input.value = normalise(input.value);
      if (input.value === '') {
        event.preventDefault();
        showError(input, input.getAttribute('data-msg-required'));
        input.focus();
        input.scrollIntoView({ behavior: 'smooth', block: 'center' });
      } else if (!FORMAT.test(input.value)) {
        event.preventDefault();
        showError(input, input.getAttribute('data-msg-format'));
        input.focus();
        input.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    },
    true
  );
})();
